package br.com.vvrefeicoes.portal.domain.model

/**
 * Colunas da planilha de "Custos de RH", na ordem em que aparecem. Os [aliases] são os cabeçalhos
 * da planilha exportada pelo sistema de folha.
 */
enum class RhCostsColumn(
    override val header: String,
    override val label: String,
    override val editable: Boolean,
    override val aliases: List<String> = emptyList(),
) : RhSheetColumn {
    EMPRESA("empresa", "Empresa", false),
    FUNCIONARIO("funcionario", "Funcionário", false),
    NOME_FUNCIONARIO("nome do funcionario", "Nome do Funcionário", false),
    FUNCAO("funcao", "Função", false),
    DEPARTAMENTO("departamento", "Departamento", false),
    GERENTE("gerente", "Gerente", false),
    DIRETORA_RESPONSAVEL("diretora / responsavel", "Diretora / Responsável", false, listOf("diretora responsavel", "diretora")),
    UNIDADE("unidade", "Unidade", false),
    DIRETORIA_UNIDADE("diretoria da unidade", "Diretoria da unidade", false),
    GESTORA_UNIDADE("gestora da unidade", "Gestora da unidade", false),
    ADMISSAO("admissao", "Admissão", false),
    SALARIO_BASE("salario base", "Salário Base", true),
    SEXO("sexo", "Sexo", false),
    RACA_COR("raca/cor", "Raça/Cor", false),
    DEMISSAO("demissao", "Demissão", false),
    CAUSA_DEMISSAO("causa da demissao", "Causa da Demissão", false),
    ATIVOS("ativos", "Ativos", true),
    ADMITIDOS("admitidos", "Admitidos", true),
    DEMITIDOS_SEM_TERMINO("demitidos (sem termino)", "Demitidos (Sem Término)", true, listOf("demitidos turnover sem termino de contrato", "demitidos sem termino de contrato")),
    DEMITIDOS_COM_TERMINO("demitidos (com termino)", "Demitidos (Com Término)", true, listOf("demitidos com termino de contrato")),
    EXTRAS_50("extras 50%", "Extras 50%", true),
    EXTRAS_100("extras 100%", "Extras 100%", true),
    DSR_EXTRAS("dsr extras", "Dsr Extras", true),
    TOTAL_EXTRAS("total extras", "Total Extras", true),
    PRODUTIVIDADE("produtividade", "Produtividade", true),
    DSR_PRODUTIVIDADE("dsr produtividade", "Dsr Produtividade", true),
    TOTAL_PRODUTIVIDADE("total produtividade", "Total Produtividade", true),
    ADICIONAL_NOTURNO("adicional noturno", "Adicional Noturno", true),
    DSR_ADIC_NOTURNO("dsr adic. noturno", "Dsr Adic. Noturno", true, listOf("dsr adicional noturno")),
    TOTAL_ADIC_NOTURNO("total adic. noturno", "Total Adic. Noturno", true, listOf("total de adicional noturno", "total adicional noturno")),
    GRATIFICACAO("gratificacao", "Gratificação", true),
    AJUDA_CUSTO("ajuda de custo", "Ajuda de Custo", true),
    DIFERENCA_SALARIO("diferenca de salario", "Diferença de Salário", true),
    TESTE("teste", "Teste", true),
    INSALUBRIDADE("insalubridade", "Insalubridade", true),
    PERICULOSIDADE("periculosidade", "Periculosidade", true),
    LIQUIDO_ADTO("liquido adto", "Líquido Adto", true, listOf("liquido adiantamento")),
    LIQUIDO_FOPAG("liquido fopag", "Líquido Fopag", true, listOf("liquido pagamento")),
    TOTAL_FOPAG("total fopag", "Total FOPAG", true),
    ;

    override val required: Boolean
        get() = this == FUNCIONARIO
}
